import { Typography } from "@mui/material";
import { OLPaper } from "OLPaper";
import { useAppSelector } from "app/hooks";
import { BoxSection } from "components/BoxSection/BoxSection";
import { ExternalLinkTooltipContent } from "components/Tooltips/ExternalLinkTooltip";
import { differenceInDays, parseISO } from "date-fns";
import { useMessage } from "hooks/intl";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import { formatCurrencyValue } from "utilities/numbers";
import { useStyles } from "./SingleMember.styles";

interface Props {
  transactionsAmount?: number;
  transactionsCount?: number;
  averageTransactionsAmount?: number;
  lastTransactionDate?: string;
  averageReturnTransactionAmount?: number;
  returnTransactionsCount?: number;
  returnTransactionsAmount?: number;
}
export const BusinessPerformance = ({
  transactionsAmount,
  transactionsCount,
  averageTransactionsAmount,
  lastTransactionDate,
  averageReturnTransactionAmount,
  returnTransactionsCount,
  returnTransactionsAmount,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const { currency } = useAppSelector(selectCurrentStoreData);

  const walletUnitsItems = [
    {
      label: message({ id: "totalSpending" }),
      value: formatCurrencyValue(transactionsAmount, "-", currency),
      tooltip: (
        <ExternalLinkTooltipContent
          name="totalSpending"
          text={message({
            id: "totalAmountOfAllRegisteredTransactionsByMember",
          })}
        />
      ),
    },
    {
      label: message({ id: "purchaseTransactions" }),
      value: transactionsCount || "-",
      tooltip: (
        <ExternalLinkTooltipContent
          name="transactions"
          text={message({ id: "totalNumberOfTransactions" })}
        />
      ),
    },
    {
      label: message({ id: "avgTransactionValue" }),
      value: formatCurrencyValue(averageTransactionsAmount, "-", currency),
      tooltip: (
        <ExternalLinkTooltipContent
          name="avgTransactionValue"
          text={message({ id: "averageValueOfTransactions" })}
        />
      ),
    },
    {
      label: message({ id: "daysSinceLastTransaction" }),
      value: lastTransactionDate
        ? differenceInDays(Date.now(), parseISO(lastTransactionDate))
        : "-",
    },
    {
      label: message({ id: "totalReturns" }),
      value: formatCurrencyValue(returnTransactionsAmount, "-", currency),
      tooltip: (
        <ExternalLinkTooltipContent
          name="totalReturns"
          text={message({ id: "allRegisteredReturnTransactionsByMember" })}
        />
      ),
    },
    {
      label: message({ id: "returnTransactions" }),
      value: returnTransactionsCount || "-",
      tooltip: (
        <ExternalLinkTooltipContent
          name="returnTransactions"
          text={message({ id: "totalNumberOfReturnTransactions" })}
        />
      ),
    },
    {
      label: message({ id: "avgReturnValue" }),
      value: formatCurrencyValue(averageReturnTransactionAmount, "-", currency),
      tooltip: (
        <ExternalLinkTooltipContent
          name="avgReturnTransactionValue"
          text={message({ id: "avgValueOfReturnTransactions" })}
        />
      ),
    },
  ];

  return (
    <>
      <Typography className={classes.header}>
        {message({ id: "businessPerformance" })}
      </Typography>
      <OLPaper noPadding>
        <BoxSection items={walletUnitsItems} />
      </OLPaper>
    </>
  );
};
